import { axiosAjax } from '@app/src/config/axios';

export const summaryService = {
  async get(categoryId: number, summaryId: string): Promise<any> {
    try {
      const { data } = await axiosAjax.get(
        process.env.API_SUMMARY
          .replace(':categoryId', String(categoryId))
          .replace(':summaryId', summaryId)
      );
      return data;
    } catch(error) {
      throw new Error(error);
    }
  }
};
